<template>
  <v-card v-if="title && text" class="card-information">
    <div
      class="text-caption text-sm-body-2 grey--text text--darken-1 font-weight-medium"
    >
      {{ title }}
    </div>

    <div class="text-subtitle-1 text-sm-h6 font-weight-bold mt-1">
      {{ text }}
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    text: [String, Number],
  },
};
</script>

<style lang="scss" scoped>
.card-information {
  background-color: #ffffff;
  border: 1px solid #ddd6d2 !important;
  border-radius: 16px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0 0 0 / 0.1) !important;
  padding: 24px;
  transition: all 0.1s linear;

  @media screen and (max-width: 599.9px) {
    border-radius: 8px !important;
    padding: 12px;
  }

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -4px rgba(0, 0, 0, 0.1) !important;
  }
}
</style>
